<template>
<div class="head_item">
  <span >{{title}}
    <img :src="state == 1 ? shang : xia " v-show="state != 0">
  </span>
</div>

</template>

<script>
import sort1 from '@/assets/img/ico_paixu_hangqing_shang.png'
import sort2 from '@/assets/img/ico_paixu_hangqing_xia.png'
export default {
  name: "Sort",
  props: {
    title: String,
    state:String
  },
  data() {
    return {
      shang:sort1,
      xia:sort2,
    };
  },
  computed:{

  },
  methods: {

  }
};
</script>

<style scoped >
.head_item {
  display: inline-block;
  width: 25%;
  text-align: center;
  font-size: 12px;
  line-height: 35px;
}
.head_item:first-child{
  width: 25%;
}
.head_item:nth-child(2){
  width: 18%;
  /*padding-left: 7px;*/
}
.head_item:nth-child(3){
  width: 31.5%;
}
.head_item span{
  display: inline-block;
  padding-right: 15px;
  position: relative;
  color: #8e8e8e;
}
.head_item span img{
  width: 7px;
  position: absolute;
  right: 5px;
  top: 12px;
}
.head_item:first-child span{
  padding-left: 15px;
}
</style>
